export const scrollTo = ref => () => {
  const elm = document.getElementById(ref);
  elm.scrollIntoView({behavior: "smooth", block: "start"});
}


// WEBPACK FOOTER //
// ./src/lib/scroll.js